import React from 'react';
import './loader.scss';

const Loader = ({isMobile, isSwappedClicked}) => {
    const positions = [
        { top: '0%', left: '50%' },
        { top: '14.64%', left: '85.36%' },
        { top: '50%', left: '100%' },
        { top: '85.36%', left: '85.36%' },
        { top: '100%', left: '50%' },
        { top: '85.36%', left: '14.64%' },
        { top: '50%', left: '0%' },
        { top: '14.64%', left: '14.64%' },
    ];

    return (
        <div className={`${isMobile && isSwappedClicked ? 'image-loader' : 'loader'}`}>
            <div className="dot-container">
                {positions.map((position, index) => (
                    <div
                        key={index}
                        className="dot"
                        style={{
                            top: position.top,
                            left: position.left,
                            animationDelay: `${index * 0.15}s`,
                        }}
                    ></div>
                ))}
            </div>
        </div>
    );
};

export default Loader;
